module.exports = __webpack_public_path__ + "img/speaker-TemurKetsbaia-imgs.b14ab044.png";